import { action, computed, observable } from 'mobx'
import { JtechStore } from 'src/plugins/mobx'

export default class ConsentLetterModel {
    @observable landfill = {};
    @observable client = {};
    @observable consentLetterItens = {};
    @observable techinicalAssessmentId = {};

    static getInstance () {
      return JtechStore.getSingleton('consentLetterModel', new ConsentLetterModel())
    }

    @action.bound setLandfill (landfill) {
      this.landfill = landfill
    }

    @action.bound setClient (client) {
      this.client = client
    }

    @action.bound setConsentLetterItens (consentLetterItens) {
      this.consentLetterItens = consentLetterItens
    }

    @action.bound setTechinicalAssessmentId (techinicalAssessmentId) {
      this.techinicalAssessmentId = techinicalAssessmentId
    }
}
